import React from 'react';

import { useNavigate } from 'react-router';
import GolfCourseIcon from '@mui/icons-material/GolfCourse';
import GolfBall from '@ui/Icons/GolfBall';
import EventAvailableOutlinedIcon from '@mui/icons-material/EventAvailableOutlined';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import { PRIVATE_PAGES } from '@app/router/pages';
import FooterLinks from '@components/FooterLinks';
import { useAppSelector } from '@app/store';

import shield from '@assets/icons/shield.svg';
import {
  DashboardContainer,
  Title,
  ActionsGroup,
  PrimaryAction,
  AssistantAction,
  SecondaryAction,
  Footer,
} from './styled';

const Dashboard = () => {
  const navigate = useNavigate();
  const club = useAppSelector((state) => state.auth.userInfo.club);

  return (
    <DashboardContainer>
      {
        !club?.logo
          ? <img src={shield} alt="shield" />
          : club?.logo.includes('http') || club?.logo.includes('https')
            ? <img src={club.logo} alt="shield" />
            : <img src={`${process.env.REACT_APP_AMAZON_S3_CDN_URL}/${club.logo}`} alt="shield" />
      }

      <Title>Welcome to Tee Swap!</Title>

      <ActionsGroup>
        <PrimaryAction
          variant="contained"
          disableElevation
          startIcon={<GolfCourseIcon />}
          onClick={() => navigate(PRIVATE_PAGES.BOOK_TICKET)}
        >
          Request a Tee Time
        </PrimaryAction>

        <AssistantAction
          variant="outlined"
          disableElevation
          startIcon={<GolfBall />}
          onClick={() => navigate(PRIVATE_PAGES.CHAT)}
        >
          Schedule with Assistant
        </AssistantAction>

        <SecondaryAction
          variant="outlined"
          disableElevation
          startIcon={<EventAvailableOutlinedIcon />}
          onClick={() => navigate(`${PRIVATE_PAGES.MY_ACCOUNT}?tab=active-requests`)}
        >
          Open/Confirmed Teetimes
        </SecondaryAction>

        <SecondaryAction
          variant="outlined"
          disableElevation
          startIcon={<PersonOutlineOutlinedIcon />}
          onClick={() => navigate(PRIVATE_PAGES.MY_ACCOUNT)}
        >
          My Account
        </SecondaryAction>
      </ActionsGroup>

      <Footer>
        <FooterLinks />
      </Footer>
    </DashboardContainer>
  );
};

export default Dashboard;
